<template>
  <b-modal
    v-model="modal"
    centered
    title="Sign Up"
    modal-class="modal-bb-squared"
    hide-footer
    v-on="$listeners"
  >
    <template #modal-header="{ close }">
      <h5>Claim your startup profile</h5>
      <p class="text-gray-700 pt-16">
        Claim your startup profile and get full access to The Hub's functionalities as a startup.
      </p>
      <button class="close" @click="close()"></button>
    </template>

    <template #default>
      <AlertSlideUpDown :show="!!promptErrorMessage">
        {{ promptErrorMessage }}
      </AlertSlideUpDown>

      <form @submit.prevent="onSubmit">
        <button type="submit" class="btn btn-lg w-100 mb-16">
          <span v-if="!isRequesting">Claim startup profile</span>
          <b-spinner v-else small />
        </button>

        <div class="fs14 mt-10">
          By sending the request you confirm that you accept our
          <router-link to="/terms" target="_blank" class="text-blue-900"
            >Terms of Service</router-link
          >
          and
          <router-link to="/privacy-policy" target="_blank" class="text-blue-900"
            >Privacy Policy</router-link
          >.
        </div>
      </form>
    </template>
  </b-modal>
</template>

<script>
import AlertSlideUpDown from '@/components/AlertSlideUpDown';

export default {
  name: 'StartupClaimModal',
  components: {
    AlertSlideUpDown
  },
  props: {
    value: {
      type: Object
    },
    startup: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      promptErrorMessage: null,
      isRequesting: false,
      claimSuccessData: {
        title: 'Your request is sent!',
        subtitle:
          'Thank you for your request to claim your startup profile. You will be informed via e-mail when we’ve approved your request or whenever we have additional questions. The reviewing process normally takes 1-2 business days.',
        image: 'paper-plane.svg',
        label: 'Close',
        width: '447'
      }
    };
  },
  computed: {
    modal: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },
  methods: {
    async onSubmit() {
      if (this.isRequesting) return;

      this.isRequesting = true;

      try {
        await this.$axios.post(`companies/${this.startup.key}/instantClaim`);
        this.$emit('submitted', this.claimSuccessData);
      } catch (err) {
        this.promptErrorMessage = err.message;
      } finally {
        this.isRequesting = false;
      }
    }
  }
};
</script>
